<template>
  <div id="app" ref="mainAppBody">
    <div v-if="isOffline"
      class="smile-no-connection"
      :style="{ backgroundImage: `url(${noInternetConnectionImg})` }"
    ></div>

    <GlobalAlert></GlobalAlert>

    <Header :isAuthenticated="isAuthenticated"></Header>

    <transition
      mode="out-in"
      :enter-active-class="enterActiveClass"
      :leave-active-class="leaveActiveClass"
    >
      <router-view @show-global-alert="showAlert" :key="$route.fullpath"></router-view>
    </transition>

    <Footer :isAuthenticated="isAuthenticated"></Footer>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import toast from '@/components/mixins/toast';
import noInternetConnectionImg from '@/assets/images/no-internet.svg';
import Header from './components/AppHeader';
import Footer from './components/AppFooter';
import GlobalAlert from './components/GlobalAlert';

const auth = createNamespacedHelpers('auth');
const network = createNamespacedHelpers('network');

export default {
  name: 'App',
  mixins: [toast],
  components: {
    Header,
    Footer,
    GlobalAlert,
  },
  data() {
    return {
      enterActiveClass: 'animated fadeIn',
      leaveActiveClass: 'animated fadeOut',
    };
  },
  computed: {
    ...network.mapState([
      'isOffline',
    ]),
    noInternetConnectionImg: () => noInternetConnectionImg,
    ...auth.mapGetters([
      'isAuthenticated',
    ]),
  },
  methods: {
    showAlert({ alertType = 'danger', payload = {} } = {}) {
      switch (alertType) {
        case 'success':
          this.showSuccessAlert(payload);
          break;

        case 'warning':
          this.showWarningAlert(payload);
          break;

        default:
          this.showDangerAlert(payload);
          break;
      }
    },
  },
  watch: {
    $route(to, from) {
      this.$refs.mainAppBody.scrollTo(0, 0);

      const fadeInTransitionClass = 'animated fadeIn';
      const fadeOutTransitionClass = 'animated fadeOut';
      const toTransition = to.meta.transitionName;
      const fromTransition = from.meta.transitionName;

      if (toTransition || fromTransition) {
        /* If going to a page with SLIDE transition */
        if (toTransition === 'slide') {
          this.enterActiveClass = 'animated slideInRight';
          this.leaveActiveClass = 'animated slideOutLeft';
        /* If coming from a page with SLIDE Transition */
        } else if (fromTransition === 'slide') {
          this.enterActiveClass = 'animated slideInLeft';
          this.leaveActiveClass = 'animated slideOutRight';
        }
      /* DEFAULT TRANSITION */
      } else {
        this.enterActiveClass = fadeInTransitionClass;
        this.leaveActiveClass = fadeOutTransitionClass;
      }
    },
  },
};
</script>

<style>
  @import './assets/css/style.css';
  @import './assets/css/animate.css';

  :root {
    --animate-duration: 150ms;
    --animate-delay: 0ms;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue